import {isMobile} from "../common/utils";

export class Sport1MaterialTabs {

    _onTabClick;
    _selector;

    constructor(selector) {
        let that = this;
        this._selector = selector;


        $(selector).each(function () {


            let $activeTab, $content, $links = $(this).find('a');

            $activeTab = $($links[0]);
            $activeTab.addClass('active');

            that.indicateSelectedTab.call(this, $activeTab);

            $content = $($activeTab[0].hash);

            $links.not($activeTab).each(function () {
                $(this.hash).hide();
            });

            $(this).on('click', 'a', function (e) {
                $activeTab.removeClass('active');
                $content.hide();

                $activeTab = $(this);
                $content = $(this.hash);

                $activeTab.addClass('active');
                $content.show();
                that.indicateSelectedTab.call($activeTab.parent(), $activeTab);

                e.preventDefault();
                if (that._onTabClick && typeof that._onTabClick == 'function') {
                    that._onTabClick.call($activeTab.parent(), e, $activeTab);
                }
            });
        });

        $(window).resize(function (e) {
            that.onResize.call(that, e)
        });

        let $tabs = $('.material-tabs');


        $tabs.each(function () {
            if ($(this).width() < this.scrollWidth) {

                if (this.scrollWidth > $(window).outerWidth()) {
                    $('.material-tabs-rail', this).css('width', this.scrollWidth+'px');
                    $('.material-nav-next', $(this).parent()).addClass('active');
                } else {
                    $('.material-tabs-rail', this).css('left', '0px');
                    $('.material-tabs-rail', this).css('right', 'initial');
                }
                $('.material-nav-next', $(this).parent()).on('click', () => {

                    this.scrollBy({left: -300, behavior: 'smooth'})
                });

                $('.material-nav-prev', $(this).parent()).on('click', () => {

                    this.scrollBy({left: 300, behavior: 'smooth'})
                })
            }
        });


        $tabs.on('scroll', function () {
            let scrollLeft = $(this).scrollLeft();
            let width = $(this).width();

            if (scrollLeft === 0) {
                $('.material-nav-prev', $(this).parent()).removeClass('active');
            } else {
                $('.material-nav-prev', $(this).parent()).addClass('active');
            }

            if (scrollLeft + width + 16 === 0) {
                $('.material-nav-next', $(this).parent()).removeClass('active');
            } else {
                $('.material-nav-next', $(this).parent()).addClass('active');
            }
        });


    }

    onResize(e) {
        const $activeTab = $('a.active', this._selector);
        const that = this;
        $activeTab.each(function () {
            that.indicateSelectedTab.call($(this).parent(), $(this));
        });
    }

    indicateSelectedTab($activeTab) {
        const $activeTabIndicator = $('.active-tab-indicator-bar', this);
        let offset = $activeTab[0].offsetLeft;
        $activeTabIndicator.css('left', `${offset}px`);
        $activeTabIndicator.css('width', $activeTab.outerWidth());
    }


    set onTabClick(onClick) {
        this._onTabClick = onClick;
    }
}
